
import { defineComponent } from "vue";

export default defineComponent({
  name: "error-500",
  components: {}
});
